import React, { useEffect, useReducer } from 'react';
import propTypes from 'prop-types';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { mostrarErro } from '@4beefopag/4bee-fopag-core/dist/molecules';
import { gravarValorCadastro } from '../../../services/apontamentoProducao';
import { actions, reducer } from './reducer';
import { Wrapper, Text, Input } from '../Apontamento';
import ModalAlteracao from '../../molecules/ModalAlteracao';

function ValorHora({ hourlyRate, horistaMensalista, requisicao, contratado, onChange, permiteEditar }) {
  const [state, dispatch] = useReducer(reducer, {
    editando: false,
    hourlyRate,
    valorHoraInicial: hourlyRate,
    mostrarModalConfirmacao: false,
    loading: false,
  });

  useEffect(() => {
    dispatch({
      type: actions.reiniciarValores,
      hourlyRate,
    });
  }, [hourlyRate]);

  const alterarValorHoraCadastro = async () => {
    dispatch({ type: actions.alterarLoading, loading: true });

    try {
      await gravarValorCadastro(requisicao, contratado, state.hourlyRate, null, horistaMensalista);
      dispatch({ type: actions.gravarValor, hourlyRate: state.hourlyRate });
      onChange(state.hourlyRate);
    } catch (err) {
      mostrarErro(err);
    } finally {
      dispatch({ type: actions.alterarLoading, loading: false });
    }
  };

  if (!state.editando) {
    return (
      <Wrapper
        disabled={!permiteEditar}
        onClick={() => {
          if (permiteEditar) {
            dispatch({ type: actions.editar });
          }
        }}
      >
        <Text
          ellipsis
          strong
        >
          {moneyFormat(state.hourlyRate, 'pt-br', {
            style: 'currency',
            currency: 'BRL',
            currencyDisplay: 'symbol',
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })}
        </Text>
        {permiteEditar && <FontAwesomeIcon icon={faPencil} />}
      </Wrapper>
    );
  }

  return (
    <>
      <Input
        autoSelect
        autoFocus
        min={0}
        casasDecimais={4}
        value={state.hourlyRate}
        onBlur={() => dispatch({ type: actions.confirmar })}
        onPressEnter={() => dispatch({ type: actions.confirmar })}
        getValue={(valor) => {
          dispatch({
            type: actions.alterarValor,
            hourlyRate: valor,
          });
        }}
        disabled={!permiteEditar}
      />

      <ModalAlteracao
        titulo="Alterar valor hora"
        visible={state.mostrarModalConfirmacao}
        onCancel={() => dispatch({ type: actions.cancelarModal })}
        onAlterarCadastro={alterarValorHoraCadastro}
        loading={state.loading}
        className="alteracao-valor-hr"
        corpoModal={
          <CustomText color="#a3a4a5">Tem certeza que deseja alterar o valor hora do colaborador?</CustomText>
        }
      />
    </>
  );
}

ValorHora.propTypes = {
  hourlyRate: propTypes.number,
  horistaMensalista: propTypes.number.isRequired,
  requisicao: propTypes.number.isRequired,
  contratado: propTypes.number.isRequired,
  onChange: propTypes.func.isRequired,
  permiteEditar: propTypes.bool,
};

ValorHora.defaultProps = {
  hourlyRate: 0.0,
  permiteEditar: true,
};

export default ValorHora;
